import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=5e8e33be&"
import script from "./SEO.vue?vue&type=script&lang=js&"
export * from "./SEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports